import { AnyAction } from 'redux';
import * as constants from 'redux/constants/marriages.constants';
import { ITableUpdate } from 'types/table.types';
import { IMarriagesFormData } from 'views/public/MarriagesView/components/MarriagesForm/types';

export const onDelete = (id: string): AnyAction => ({
  type: constants.MARRIAGES_ON_DELETE_REQUESTED,
  id,
});

export const onDeleteFile = (id: string, fileId: string): AnyAction => ({
  type: constants.MARRIAGES_ON_DELETE_FILE_REQUESTED,
  id,
  fileId,
});

export const onGetAll = (data: ITableUpdate): AnyAction => ({
  type: constants.MARRIAGES_ON_GET_ALL_REQUESTED,
  ...data,
});

export const onGetForm = (): AnyAction => ({
  type: constants.MARRIAGES_ON_GET_FORM_REQUESTED,
});

export const onGetOne = (id: string): AnyAction => ({
  type: constants.MARRIAGES_ON_GET_ONE_REQUESTED,
  id,
});

export const onSave = (formData: IMarriagesFormData, id?: string): AnyAction => ({
  type: constants.MARRIAGES_ON_SAVE_REQUESTED,
  formData,
  id,
});
